
import { useState, useEffect } from 'react';
import { getScrollClasses } from '../utils/scrollUtils';

export const useResponsiveScroll = () => {
  const [scrollClasses, setScrollClasses] = useState(getScrollClasses());
  
  useEffect(() => {
    const handleResize = () => {
      setScrollClasses(getScrollClasses());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return scrollClasses;
};
